/** Public, deep-linkable auth route paths. The route IS the mode. */
export const AUTH_PATHS = {
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  verifyEmail: '/verify-email',
} as const;

export type AuthPath = (typeof AUTH_PATHS)[keyof typeof AUTH_PATHS];

/** All public auth paths — apps use this to register routes / mark them public. */
export const AUTH_PATH_LIST: readonly AuthPath[] = Object.values(AUTH_PATHS);
